import { useEffect, useState } from "react";
import { Spin } from "antd";
import { fetchMySubscription } from "../api/subscriptionsApi";
import { handleUnauthorized, isUnauthorizedError } from "../utils/authSession";
import SubscriptionBlockedPage from "./SubscriptionBlockedPage";

export default function SubscriptionGate({ role, children }) {
  const [status, setStatus] = useState("loading");
  const [state, setState] = useState("none");

  useEffect(() => {
    let on = true;
    (async () => {
      try {
        const data = await fetchMySubscription();
        if (!on) return;
        if (data?.required === false || data?.access_state === "active") {
          setState("active");
          setStatus("ok");
          return;
        }
        setState(data?.access_state || "none");
        setStatus("blocked");
      } catch (err) {
        if (!on) return;
        if (isUnauthorizedError(err)) {
          handleUnauthorized();
          return;
        }
        setState("none");
        setStatus("blocked");
      }
    })();
    return () => {
      on = false;
    };
  }, []);

  if (status === "loading") {
    return (
      <div className="cl-sub-block">
        <Spin />
      </div>
    );
  }

  if (status === "blocked") {
    return <SubscriptionBlockedPage state={state} role={role} />;
  }

  return children;
}
